import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  MAINNET = 1,
  ROPSTEN = 3,
  RINKEBY = 4,
  GÖRLI = 5,
  KOVAN = 42,
  MATIC = 137,
  MATIC_TESTNET = 80001,
  FANTOM = 250,
  FANTOM_TESTNET = 4002,
  XDAI = 100,
  BSC = 56,
  BSC_TESTNET = 97,
  ARBITRUM = 79377087078960,
  MOONBASE = 1287,
  AVALANCHE = 43114,
  FUJI = 43113,
  HECO = 128,
  HECO_TESTNET = 256,
  HARMONY = 1666600000,
  HARMONY_TESTNET = 1666700000,
  OKEX = 66,
  OKEX_TESTNET = 65
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

export const INIT_CODE_HASH: string = '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303'

export const FACTORY_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.ROPSTEN]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.RINKEBY]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.GÖRLI]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.KOVAN]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.FANTOM]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.MATIC_TESTNET]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.XDAI]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.BSC]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.BSC_TESTNET]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '0x2Ce3F07dD4c62b56a502E223A7cBE38b1d77A1b5',
  [ChainId.AVALANCHE]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.FUJI]: '0xd00ae08403B9bbb9124bB305C09058E32C39A48c',
  [ChainId.HECO]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.HECO_TESTNET]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.HARMONY]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.HARMONY_TESTNET]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.OKEX]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d',
  [ChainId.OKEX_TESTNET]: '0xfe87e130e2b13d842c4ca99f6e6567712f97c64d'
}

export const ROUTER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.RINKEBY]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.ROPSTEN]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.GÖRLI]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.KOVAN]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.FANTOM]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.MATIC_TESTNET]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.XDAI]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.BSC]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.BSC_TESTNET]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '0xeB5c2BB5E83B51d83F3534Ae21E84336B8B376ef',
  [ChainId.AVALANCHE]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.FUJI]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.HECO]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.HECO_TESTNET]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.HARMONY]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.HARMONY_TESTNET]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.OKEX]: '0x7156b23feaf295e109d69148665bff737809cea4',
  [ChainId.OKEX_TESTNET]: '0x7156b23feaf295e109d69148665bff737809cea4'
}

export const SUSHI_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xd2bc5ce54fe77dd93ad48012eaf756c85e043b24',
  [ChainId.ROPSTEN]: '0xd2bc5ce54fe77dd93ad48012eaf756c85e043b24',
  [ChainId.RINKEBY]: '0xd2bc5ce54fe77dd93ad48012eaf756c85e043b24',
  [ChainId.GÖRLI]: '0xd2bc5ce54fe77dd93ad48012eaf756c85e043b24',
  [ChainId.KOVAN]: '0xd2bc5ce54fe77dd93ad48012eaf756c85e043b24',
  [ChainId.FANTOM]: '',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_TESTNET]: '',
  [ChainId.XDAI]: '',
  [ChainId.BSC]: '',
  [ChainId.BSC_TESTNET]: '',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FUJI]: '',
  [ChainId.HECO]: '',
  [ChainId.HECO_TESTNET]: '',
  [ChainId.HARMONY]: '',
  [ChainId.HARMONY_TESTNET]: '',
  [ChainId.OKEX]: '',
  [ChainId.OKEX_TESTNET]: ''
}

export const MASTERCHEF_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x8e796487546d9719e66ad514f8dddf0bcc51c20f',
  [ChainId.ROPSTEN]: '0x8e796487546d9719e66ad514f8dddf0bcc51c20f',
  [ChainId.RINKEBY]: '0x8e796487546d9719e66ad514f8dddf0bcc51c20f',
  [ChainId.GÖRLI]: '0x8e796487546d9719e66ad514f8dddf0bcc51c20f',
  [ChainId.KOVAN]: '0x8e796487546d9719e66ad514f8dddf0bcc51c20f',
  [ChainId.FANTOM]: '',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_TESTNET]: '',
  [ChainId.XDAI]: '',
  [ChainId.BSC]: '',
  [ChainId.BSC_TESTNET]: '',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FUJI]: '',
  [ChainId.HECO]: '',
  [ChainId.HECO_TESTNET]: '',
  [ChainId.HARMONY]: '',
  [ChainId.HARMONY_TESTNET]: '',
  [ChainId.OKEX]: '',
  [ChainId.OKEX_TESTNET]: ''
}

export const BAR_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xbabb5302365aec83b4468056464ee3e07a8b4b1a',
  [ChainId.ROPSTEN]: '0xbabb5302365aec83b4468056464ee3e07a8b4b1a',
  [ChainId.RINKEBY]: '0xbabb5302365aec83b4468056464ee3e07a8b4b1a',
  [ChainId.GÖRLI]: '0xbabb5302365aec83b4468056464ee3e07a8b4b1a',
  [ChainId.KOVAN]: '0xbabb5302365aec83b4468056464ee3e07a8b4b1a',
  [ChainId.FANTOM]: '',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_TESTNET]: '',
  [ChainId.XDAI]: '',
  [ChainId.BSC]: '',
  [ChainId.BSC_TESTNET]: '',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FUJI]: '',
  [ChainId.HECO]: '',
  [ChainId.HECO_TESTNET]: '',
  [ChainId.HARMONY]: '',
  [ChainId.HARMONY_TESTNET]: '',
  [ChainId.OKEX]: '',
  [ChainId.OKEX_TESTNET]: ''
}

export const MAKER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x65beaff5fbd91de64588cfd8ef6803fecf2e50c8',
  [ChainId.ROPSTEN]: '0x65beaff5fbd91de64588cfd8ef6803fecf2e50c8',
  [ChainId.RINKEBY]: '0x65beaff5fbd91de64588cfd8ef6803fecf2e50c8',
  [ChainId.GÖRLI]: '0x65beaff5fbd91de64588cfd8ef6803fecf2e50c8',
  [ChainId.KOVAN]: '0x65beaff5fbd91de64588cfd8ef6803fecf2e50c8',
  [ChainId.FANTOM]: '',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_TESTNET]: '',
  [ChainId.XDAI]: '',
  [ChainId.BSC]: '',
  [ChainId.BSC_TESTNET]: '',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FUJI]: '',
  [ChainId.HECO]: '',
  [ChainId.HECO_TESTNET]: '',
  [ChainId.HARMONY]: '',
  [ChainId.HARMONY_TESTNET]: '',
  [ChainId.OKEX]: '',
  [ChainId.OKEX_TESTNET]: ''
}

export const TIMELOCK_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x9a8541Ddf3a932a9A922B607e9CF7301f1d47bD1',
  [ChainId.ROPSTEN]: '',
  [ChainId.RINKEBY]: '',
  [ChainId.GÖRLI]: '',
  [ChainId.KOVAN]: '',
  [ChainId.FANTOM]: '',
  [ChainId.FANTOM_TESTNET]: '',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_TESTNET]: '',
  [ChainId.XDAI]: '',
  [ChainId.BSC]: '',
  [ChainId.BSC_TESTNET]: '',
  [ChainId.ARBITRUM]: '',
  [ChainId.MOONBASE]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FUJI]: '',
  [ChainId.HECO]: '',
  [ChainId.HECO_TESTNET]: '',
  [ChainId.HARMONY]: '',
  [ChainId.HARMONY_TESTNET]: '',
  [ChainId.OKEX]: '',
  [ChainId.OKEX_TESTNET]: ''
}

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
